import React, {useCallback, useEffect, useState} from 'react';
import {dialogAlert, dialogConfirm} from '../../../../elements/Dialog/dialogs';
import './JoinEventFromParent.scss';

const JoinEventFromParent = props => {
    const {event, i18n} = props,
        [joined, setJoined] = useState(event.joined),
        [canJoin, setCanJoin] = useState(event.can_join),
        [unregistered, setUnregistered] = useState(event.unregistered);

    useEffect(() => {
        setJoined(event.joined);
        setCanJoin(event.can_join);
        setUnregistered(event.unregistered);
    }, [event.joined, event.can_join, event.unregistered]);

    const handleJoin = useCallback(() => {
        setJoined(true);
        setUnregistered(false);

        app.store.dispatch(app.actions.ui.busy());
        app.api.events
            .joinEvent(event.id)
            .then(() => {
                if (!event.agenda_type) {
                    app.history.push(['/events', event.id].join('/'));
                }
            })
            .catch(async error => {
                if (_.get(error, 'request.status') == 409) {
                    await dialogAlert(i18n['message.event-capacity-reached']);
                } else {
                    console.error(error);
                }
            })
            .then(() => app.store.dispatch(app.actions.ui.free()));
    }, [event]);

    const handleLeave = useCallback(async () => {
        if (await dialogConfirm(i18n['label.leave-event-confirm'])) {
            setJoined(false);
            setCanJoin(true);
            setUnregistered(true);

            app.store.dispatch(app.actions.ui.busy());
            app.api.events
                .leaveEvent(event.id)
                .catch(console.error)
                .then(() => app.store.dispatch(app.actions.ui.free()));
        }
    }, [event]);

    return (
        <div
            className={['JoinEventFromParent', !joined && !canJoin ? 'full' : '', unregistered ? 'unregistered' : ''].join(' ')}
            style={{
                backgroundColor: event.settings.primary_color,
            }}>
            <div className="label VerticalCenter">{i18n['label.event-join']}</div>
            <button type="button" className={[joined ? 'joined' : 'join'].join(' ')} onClick={handleJoin} disabled={!canJoin}>
                {!joined && !canJoin ? (
                    <div className="full">
                        <div>{i18n['label.full']}</div>
                    </div>
                ) : null}
            </button>
            <button type="button" className="leave" onClick={handleLeave} disabled={unregistered}></button>
        </div>
    );
};

export default JoinEventFromParent;
